import { z } from "zod";
import { listQuerySchema, quantityField } from "./common.js";
export const stockLocationSchema = z.object({
    code: z.string().trim().min(1, "Code is required.").max(16),
    name: z.string().trim().min(1, "Name is required.").max(120),
    kind: z.enum(["store", "floor", "quarantine", "other"]).default("store"),
});
export const stockAdjustSchema = z.object({
    materialId: z.string().uuid("Invalid material id."),
    locationId: z.string().uuid("Invalid location id."),
    direction: z.enum(["in", "out"]),
    quantity: quantityField,
    reason: z.string().trim().min(3, "A short reason is required.").max(500),
    allowNegative: z.boolean().optional(),
});
export const stockIssueSchema = z.object({
    jobId: z.string().uuid("Invalid job id."),
    materialId: z.string().uuid("Invalid material id."),
    locationId: z.string().uuid("Invalid location id."),
    quantity: quantityField,
    allowNegative: z.boolean().optional(),
});
export const stockReturnSchema = z.object({
    jobId: z.string().uuid("Invalid job id."),
    materialId: z.string().uuid("Invalid material id."),
    locationId: z.string().uuid("Invalid location id."),
    quantity: quantityField,
});
export const stockReverseSchema = z.object({
    reason: z.string().trim().min(3, "A short reason is required.").max(500),
});
export const stockLocationIdParamSchema = z.object({
    id: z.string().uuid("Invalid location id."),
});
export const stockMovementIdParamSchema = z.object({
    movementId: z.string().uuid("Invalid movement id."),
});
export const materialIdParamSchema = z.object({
    materialId: z.string().uuid("Invalid material id."),
});
export const materialStockQuerySchema = listQuerySchema.extend({
    materialId: z.string().uuid().optional(),
});
//# sourceMappingURL=inventory.js.map